import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { KollelFormData } from '../schemas/kollelFormSchema';
import Checkbox from '@/components/ui/Checkbox/Checkbox';

/** Step 5 of 5 — "חתימה על הצהרות משפטיות", the Figma spec's final wizard phase (from the intro
 * screen's step list), after the stipend step (HAT-1446 phase 4). */
const KollelTermsStep = () => {
  const { t } = useTranslation();
  const { watch, setValue, formState: { errors } } = useFormContext<KollelFormData>();

  const legalTermsApproved = watch('legalTermsApproved') ?? false;

  return (
    <div className="w-full flex flex-col gap-4">
      <h3 className="heading-h3-semibold text-(--font-primary)">{t('kollels.wizard.step5.title')}</h3>
      <div className="flex flex-col gap-1">
        <div className="flex items-start gap-3 bg-(--surface-secondary) rounded-lg p-4">
          <Checkbox
            checked={legalTermsApproved}
            onCheckedChange={(checked) => setValue('legalTermsApproved', checked, { shouldValidate: true })}
            ariaLabelledBy="kollel-legal-terms-text"
            ariaInvalid={!!errors.legalTermsApproved}
            ariaRequired
          />
          <span id="kollel-legal-terms-text" className="body-sm-regular">
            {t('kollels.wizard.step5.legalPrefix')}{' '}
            <a href="/terms" target="_blank" rel="noreferrer" className="underline">
              {t('kollels.wizard.step5.legalLink')}
            </a>{' '}
            {t('kollels.wizard.step5.legalSuffix')}
          </span>
        </div>
        {errors.legalTermsApproved && (
          <p className="text-red-500 body-sm-regular">{errors.legalTermsApproved.message}</p>
        )}
      </div>
    </div>
  );
};

export default KollelTermsStep;
